module.exports = __webpack_public_path__ + "img/Group.b6d00a89.svg";